import { SVGProps } from 'react';

export const ShareIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2347 3.49773L17.3264 7.11539C18.9421 8.54398 19.75 9.25828 19.75 10.1785C19.75 11.0987 18.9421 11.813 17.3264 13.2416L13.2347 16.8592C12.4972 17.5113 12.1285 17.8374 11.8244 17.7016C11.5204 17.5657 11.5204 17.075 11.5204 16.0935V13.6913C7.81223 13.6913 3.79506 15.4477 2.25 18.375C2.25 9.00754 7.74356 6.66568 11.5204 6.66568V4.2635C11.5204 3.28197 11.5204 2.7912 11.8244 2.6554C12.1285 2.51959 12.4972 2.84563 13.2347 3.49773Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
